<template>
  <div>
    <modal
      name="modal-templates"
      height="auto"
      width="50%"
      scrollable
      class="modal-templates"
    >
      <!-- @click="hideModalImagem" -->
      <div class="container text-center">
        <div class="d-flex justify-content-end">
          <!-- TODO: Verificar o porquê de remover quando for edição -->
          <div
            class="back-arrow-squared mt-3"
            @click="hideModalTemplates"
            style="cursor: pointer"
          >
            <i class="fa-solid fa-xmark" style="font-size: 12px"></i>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <span class="p-input-icon-left pb-2 pt-4" style="width: 100%">
              <i class="pi pi-search" />
              <InputText
                style="width: 100%"
                type="text"
                v-model="searchTemplateValue"
                placeholder="Pesquisar template"
              />
            </span>
            <ScrollPanel
              style="width: 100%; height: 500px; overflow-y: hidden !important"
            >
              <Card
                class="btn-light m-5 p-0"
                :class="{
                  'is-template-wp-selected': isTemplateWppSelected(template)
                }"
                v-for="(template, key) in filtrarTemplate"
                :key="key"
              >
                <template #content>
                  <div class="row pl-5 pr-5">
                    <div class="col-6">
                      <div class="row">
                        <div class="col-12">
                          <div
                            style="
                              background-color: #6c757d36;
                              height: 100%;
                              color: black;
                              border-radius: 5px;
                            "
                            class="pt-6 pl-6 pr-6"
                          >
                            <p class="mb-0">ID: {{ template.id }}</p>
                            <h4
                              class="mb-6"
                              style="
                                text-transform: uppercase;
                                color: black;
                                overflow-wrap: break-word;
                              "
                            >
                              Nome: {{ template.name }}
                            </h4>
                            <TemplateWppVariaveis
                              v-model="filtrarTemplate[key]"
                              :options="variaveisDeTextoNome"
                            ></TemplateWppVariaveis>
                          </div>
                        </div>
                        <div class="col-12" v-if="template">
                          <div
                            v-for="component in template.components"
                            :key="component.name"
                          >
                            <div
                              v-for="(data, key) in variaveisFor(component)"
                              :key="key"
                              class="pt-3"
                            >
                              <label
                                :for="component.type"
                                v-if="
                                  variaveisComponent(component, true).length > 0
                                "
                              >
                                {{ component.type }}
                              </label>
                              <div
                                v-for="(variable, variableKey) in data"
                                :key="variableKey"
                              >
                                <div
                                  class="d-flex w-100 mt-2"
                                  v-for="(v, k) in variaveisComponent(
                                    component,
                                    true
                                  )"
                                  :key="k"
                                >
                                  <span
                                    class="p-inputgroup-addon w-25"
                                    v-html="`{{${k + 1}}}`"
                                  />
                                  <Dropdown
                                    filter
                                    :inputId="`i-dp-${k}`"
                                    editable
                                    filterPlaceholder="Pesquisar"
                                    appendTo="body"
                                    emptyFilterMessage="Variável não encontrada"
                                    :key="updateDropdownTemplate"
                                    @input="forceUpdateDropdownTemplates"
                                    v-model="
                                      variaveisSelecionadas[
                                        `${template.name}|${component.type}${
                                          component.type == 'BUTTONS'
                                            ? variableKey
                                            : ''
                                        }|${v}`
                                      ]
                                    "
                                    :options="variaveisDeTextoNome"
                                    placeholder="Digite ou selecione a variável"
                                    style="text-align: left"
                                    class="md:w-14rem w-100"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <PreviewWhatsapp
                        style="
                          color: black;
                          text-align: left;
                          border-radius: 5px;
                        "
                        v-model="template.components"
                      >
                      </PreviewWhatsapp>
                    </div>
                    <div class="col-12 pt-4">
                      <b-button
                        :disabled="!validaTemplate(template)"
                        class="btn btn-primary btn-block btn-success"
                        @click="selecionarTemplate(template)"
                      >
                        <!-- v-tooltip.bottom="{
                          value:
                            'Informe todas as variáveis para selecionar o template',
                          disabled: validaTemplate(template)
                        }" -->
                        Selecionar Template
                      </b-button>
                    </div>
                  </div>
                </template>
              </Card>
            </ScrollPanel>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { watch } from "vue";

export default {
  name: "SelecionarTemplate",
  components: {
    ScrollPanel: () => import("primevue/scrollpanel"),
    InputText: () => import("primevue/inputtext"),
    Card: () => import("primevue/card/Card"),
    Dropdown: () => import("primevue/dropdown"),
    PreviewWhatsapp: () =>
      import(
        "@/view/pages/painel/automacao/template-whatsapp/PreviewWhatsapp.vue"
      ),
    TemplateWppVariaveis: () =>
      import(
        "@/view/pages/painel/automacao/campanha/components/TemplateWppVariaveis.vue"
      )
  },
  props: {
    texto: {
      type: String,
      default: ""
    },
    templates: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchTemplateValue: "",
      templateOptions: [],
      variaveisDeTextoNome: [],
      updateDropdownTemplate: 1,
      debounceDropdown: null,
      variaveisSelecionadas: {},
      templateSelecionadoWpp: {},
      textoWpp: ""
    };
  },
  computed: {
    filtrarTemplate() {
      return this.templates.filter((v) => {
        return (
          v.status === "APPROVED" && v.name.includes(this.searchTemplateValue)
        );
      });
    }
  },
  watch: {
    texto: {
      immediate: true,
      handler(novoTexto) {
        if (novoTexto && novoTexto.includes("@template")) {
          this.carregarVariaveisDoTexto(novoTexto);
        }
      }
    }
  },
  methods: {
    variaveisComponent(component, unique = false) {
      const variaveis = [];
      if (component && component.text) {
        const matches = component.text.match(/{{\d+}}/g) || [];
        for (const match of matches) {
          if (unique && !variaveis.includes(match)) {
            variaveis.push(match);
          }
        }
      } else if (component && component.type === "BUTTONS") {
        for (const b of component.buttons) {
          if (b.example) {
            const matches = b.url.match(/{{\d+}}/g) || [];
            for (const match of matches) {
              if (unique && !variaveis.includes(match)) {
                variaveis.push(match);
              }
            }
          }
        }
      }
      return variaveis;
    },
    hideModalTemplates() {
      this.$modal.hide("modal-templates");
    },
    isTemplateWppSelected(template) {
      let canal = this.campaing_to_edit_on_retrocompatibility?.CANAIS.find(
        (i) => i.can_nome == "Whatsapp"
      );
      if (canal) {
        let matches = canal.cac_mensagem?.match(/\((.*?)&&/g);
        let nameTemplate = matches
          ? matches[0].replace("&&", "").replace("(", "")
          : "";
        if (template.name == nameTemplate) {
          return true;
        }
      }
      return false;
    },
    forceUpdateDropdownTemplates(value) {
      const time = this.variaveisDeTextoNome.includes(value) ? 0 : 1500;
      clearTimeout(this.debounceDropdown);
      this.debounceDropdown = setTimeout(() => {
        this.updateDropdownTemplate++;
      }, time);
    },
    validaTemplate(template) {
      if (
        Object.values(this.variaveisSelecionadas).some((v) => v.trim() === "")
      ) {
        return false;
      }
      const variaveis = Object.keys(this.variaveisSelecionadas).filter((v) => {
        return v.split("|")[0].includes(template.name);
      });
      return variaveis.length >= this.variaveisTemplate(template, true).length;
    },
    variaveisTemplate(template, unique = false) {
      let variaveis = [];
      for (const component of template.components) {
        variaveis = variaveis.concat(
          this.variaveisComponent(component, unique)
        );
      }
      return variaveis;
    },
    variaveisFor(component) {
      if (component.type === "BUTTONS") {
        return {
          button_examples: component.buttons.filter((b) => b.example)
        };
      } else {
        return component.example;
      }
    },
    selecionarTemplate(template) {
      this.templateSelecionadoWpp = template;
      if (this.validaTemplate(template)) {
        let text = "";
        const variaveis = this.getVariaveisSelecionadas(template);

        template.components.forEach((component) => {
          const varComponent = Object.keys(variaveis).filter((k) => {
            return k.split("|")[1] === component.type;
          });
          if (component.text) {
            let texto = component.text;
            for (const varComponentKey in varComponent) {
              const varComponentValue = varComponent[varComponentKey];
              texto = texto.replace(
                varComponentValue.split("|")[2],
                this.variaveisDeTextoNome.includes(variaveis[varComponentValue])
                  ? "{" + variaveis[varComponentValue] + "}"
                  : variaveis[varComponentValue]
              );
            }
            text += texto + "\n";
          }
        });
        this.textoWpp = text;
        this.$forceUpdate();
        let aux = "";
        let valores = Object.values(variaveis);
        valores = valores.map((v) => {
          return this.variaveisDeTextoNome.includes(v) ? "{" + v + "}" : v;
        });
        if (valores.length) {
          aux = "&&" + valores.join("&&");
        }
        this.textoWpp += `@template(${template.name}${aux})`;
        this.$emit("selecionado", { texto: this.textoWpp, template: template });
        this.hideModalTemplates();
      }
    },
    getVariaveisSelecionadas(template) {
      if (template) {
        let quant = this.getVariaveisTemplate(template);
        let variaveis = [];
        for (const variaveisSelecionadasKey in this.variaveisSelecionadas) {
          if (variaveisSelecionadasKey.split("|")[0].includes(template.name)) {
            variaveis[variaveisSelecionadasKey] =
              this.variaveisSelecionadas[variaveisSelecionadasKey];
          }
        }

        let arrayBodyKey = Object.keys(variaveis).filter((k) =>
          k.split("|")[1].replace(/[0-9]/g, "").includes("BODY")
        );
        let arrayButtonsKey = Object.keys(variaveis).filter((k) =>
          k.split("|")[1].replace(/[0-9]/g, "").includes("BUTTONS")
        );

        arrayBodyKey = arrayBodyKey.slice(0, quant.BODY);
        arrayButtonsKey = arrayButtonsKey.slice(0, quant.BUTTONS);

        let aux = {};
        for (const key in variaveis) {
          if (arrayBodyKey.includes(key) || arrayButtonsKey.includes(key)) {
            aux[key] = variaveis[key];
          }
        }
        variaveis = aux;

        if (quant.BODY === 0) {
          for (const v in variaveis) {
            if (v.includes("BODY")) {
              delete variaveis[v];
            }
          }
        }

        if (quant.BUTTONS === 0) {
          for (const v in variaveis) {
            if (v.includes("BUTTONS")) {
              delete variaveis[v];
            }
          }
        }
        return variaveis;
      }
      return this.variaveisSelecionadas;
    },
    getVariaveisTemplate(template) {
      let componentes = template?.components;
      let body = componentes.find((c) => c.type === "BODY");
      let quant_body = body?.example ? body?.example.body_text[0].length : 0;

      let buttons = componentes.find((c) => c.type === "BUTTONS");
      let quant_buttons = buttons?.buttons
        ? buttons?.buttons.reduce((soma, item) => {
            return soma + (item.example ? item.example.length : 0);
          }, 0)
        : 0;
      return { BODY: quant_body, BUTTONS: quant_buttons };
    },
    carregarVariaveisDoTexto(texto) {
      const resultado = this.inicializarVariaveisDoTexto(texto, this.templates);

      if (resultado.sucesso) {
        // Preenche os dropdowns automaticamente!
        this.variaveisSelecionadas = {
          ...this.variaveisSelecionadas,
          ...resultado.variaveisSelecionadas
        };

        this.templateSelecionadoWpp = resultado.templateEncontrado;

        this.$nextTick(() => {
          this.updateDropdownTemplate++;
        });
      }
    },
    inicializarVariaveisDoTexto(texto, templates) {
      const templateExtraido = this.extrairTemplate(texto);

      if (!templateExtraido.temTemplate) {
        return {
          sucesso: false,
          mensagem: "Nenhum template encontrado no texto",
          variaveisSelecionadas: {},
          templateEncontrado: null
        };
      }

      // Busca o template correspondente
      const templateMeta = templates.find(
        (t) =>
          t.name === templateExtraido.nomeTemplate && t.status === "APPROVED"
      );

      if (!templateMeta) {
        return {
          sucesso: false,
          mensagem: `Template "${templateExtraido.nomeTemplate}" não encontrado ou não aprovado`,
          variaveisSelecionadas: {},
          templateEncontrado: null
        };
      }

      const variaveisSelecionadas = this.mapearVariaveisParaVue(
        templateExtraido,
        templateMeta
      );

      return {
        sucesso: true,
        mensagem: "Variáveis mapeadas com sucesso",
        variaveisSelecionadas,
        templateEncontrado: templateMeta,
        templateExtraido
      };
    },
    extrairTemplate(text) {
      if (!text || typeof text !== "string") {
        throw new Error("Texto inválido. Forneça uma string válida.");
      }

      const templateRegex = /@template\s*\(\s*([^)]+)\s*\)/i;
      const match = text.match(templateRegex);

      if (!match) {
        return {
          temTemplate: false,
          nomeTemplate: null,
          variaveis: [],
          corpo: text.trim(),
          totalVariaveis: 0
        };
      }

      const conteudoTemplate = match[1].trim();
      const partes = conteudoTemplate
        .split("&&")
        .map((parte) => parte.trim())
        .filter((parte) => parte.length > 0);

      const nomeTemplate = partes[0] || null;
      const variaveis = partes.slice(1);
      const corpo = text.replace(templateRegex, "").trim();

      const mapeamentoVariaveis = variaveis.map((nomeVar, index) => {
        const regex = new RegExp(`\\b${nomeVar}\\b`, "g");
        const ocorrencias = [];
        let matchVar;

        while ((matchVar = regex.exec(corpo)) !== null) {
          ocorrencias.push({
            posicao: matchVar.index,
            contexto: corpo.substring(
              Math.max(0, matchVar.index - 20),
              Math.min(corpo.length, matchVar.index + nomeVar.length + 20)
            )
          });
        }

        return {
          nome: nomeVar,
          index: index + 1,
          ocorrencias: ocorrencias.length,
          posicoesNoTexto: ocorrencias
        };
      });

      return {
        temTemplate: true,
        nomeTemplate,
        variaveis,
        totalVariaveis: variaveis.length,
        corpo,
        mapeamentoVariaveis,
        templateCompleto: match[0]
      };
    },
    mapearVariaveisParaVue(templateExtraido, templateMeta) {
      if (!templateExtraido.temTemplate) {
        return {};
      }

      if (!templateMeta || !templateMeta.components) {
        return {};
      }

      // Verifica se os nomes batem
      if (templateExtraido.nomeTemplate !== templateMeta.name) {
        console.warn(
          `Aviso: Nome do template não corresponde. ` +
            `Extraído: "${templateExtraido.nomeTemplate}", Meta: "${templateMeta.name}"`
        );
      }

      const variaveisSelecionadas = {};
      let indexVariavel = 0;

      templateMeta.components.forEach((component) => {
        // Para BODY e HEADER
        if (
          (component.type === "BODY" || component.type === "HEADER") &&
          component.text
        ) {
          const matches = component.text.match(/{{\d+}}/g) || [];

          matches.forEach((match) => {
            if (indexVariavel < templateExtraido.variaveis.length) {
              const nomeVariavel = templateExtraido.variaveis[indexVariavel];
              const chave = `${templateMeta.name}|${component.type}|${match}`;

              // Remove chaves {} se existirem na variável
              variaveisSelecionadas[chave] = nomeVariavel.replace(/^{|}$/g, "");
              indexVariavel++;
            }
          });
        }

        // Para BUTTONS
        if (component.type === "BUTTONS" && component.buttons) {
          component.buttons.forEach((button, buttonIndex) => {
            if (button.example && button.url) {
              const matches = button.url.match(/{{\d+}}/g) || [];

              matches.forEach((match) => {
                if (indexVariavel < templateExtraido.variaveis.length) {
                  const nomeVariavel =
                    templateExtraido.variaveis[indexVariavel];
                  const chave = `${templateMeta.name}|${component.type}${buttonIndex}|${match}`;

                  variaveisSelecionadas[chave] = nomeVariavel.replace(
                    /^{|}$/g,
                    ""
                  );
                  indexVariavel++;
                }
              });
            }
          });
        }
      });

      return variaveisSelecionadas;
    }
  }
};
</script>

<style scoped lang="scss"></style>
